import './CRUDAgent.scss';
import Component from './CRUDAgent';
export default Component;
